import { Component } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { catchError, of, Subject, switchMap, takeUntil } from 'rxjs';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ThemeService } from '@modules/settings/services/theme.service';
import { Theme } from '@modules/settings/types/theme';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrl: './reset-password.component.less',
    standalone: false
})
export class ResetPasswordComponent {

  // Public
  public password?: string;
  public confirmPassword?: string;
  public error?: string;
  public user?: {
    email: string,
    role: string,
    teamId: string;
  };
  public theme?: Theme;

  // Private
  private alive = new Subject<void>();

  /**
   * Constructor
   */

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private themeService: ThemeService,
  ) { }

  /**
   * Component lifecycle
   */

  ngOnInit(): void {
    this.route.queryParamMap
      .pipe(
        switchMap((params: ParamMap) => {
          const token = params.get('token');
          if (!token) {
            this.error = 'User not found';
            return of(undefined);
          }
          return this.authService.validateToken(token);
        }),
        catchError(error => {
          if (error) {
            this.error = ((error.error.message instanceof Array) ? error.error.message.join('\n') : error.error.message);
          }
          return of();
        }),
        takeUntil(this.alive)
      )
      .subscribe(user => {
        this.user = user;
        if (!user) {
          this.error = 'User not found';
        }
      });
    // Theme
    this.theme = this.themeService.theme;
  }

  ngOnDestroy(): void {
    this.alive.next();
    this.alive.complete();
  }

  /**
   * Methods
   */

  complete(): void {
    if (this.password !== this.confirmPassword) {
      this.error = 'Password and cofirm password are different';
      return;
    }
    if (this.password?.length && this.user?.email) {
      this.authService.completeRegistration(this.user.email, this.password)
        .pipe(
          catchError(error => {
            if (error) {
              this.error = ((error.error.message instanceof Array) ? error.error.message.join('\n') : error.error.message);
            }
            return of();
          }),
          switchMap(response => this.authService.login(this.user!.email, this.password!)),
          takeUntil(this.alive)
        )
        .subscribe(() => {});
    }
  }

}
